import React from 'react';
import { PbPageProps } from 'modules/page-builder';
import { BuildPC } from 'modules/buildpc/desktop';
import { getServerSidePropsBuildPC } from 'modules/buildpc/shared';
import { BuildPCV2Provider, BuildPcProvider, useTenantConfig } from 'contexts';

const BuildPcPage: React.FunctionComponent<PbPageProps> = (props) => {
  const { epicOmni1524 } = useTenantConfig();
  const BuildPCProvider = !!epicOmni1524 ? BuildPCV2Provider : BuildPcProvider;

  return (
    <BuildPCProvider>
      <BuildPC {...props} />
    </BuildPCProvider>
  );
};

export const getServerSideProps = getServerSidePropsBuildPC;

export default BuildPcPage;
